export default "__VITE_ASSET__d4dd6098__"